const LABELS = ["Velmi slabé", "Slabé", "Střední", "Dobré", "Silné"];
const COLORS = ["#ef4444", "#f97316", "#eab308", "#84cc16", "#22c55e"];

export function passwordScore(pw) {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 10) s++;
  if (pw.length >= 14) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
}

export function PasswordStrength({ password }) {
  if (!password) return null;
  const score = passwordScore(password);
  const ok = password.length >= 10;
  return (
    <div data-testid="password-strength" className="mt-2">
      <div className="flex gap-1">
        {[0, 1, 2, 3].map((i) => (
          <div
            key={i}
            className="h-1.5 flex-1 rounded-full transition-colors duration-200"
            style={{ background: i < score ? COLORS[score] : "var(--border)" }}
          />
        ))}
      </div>
      <p className="text-xs mt-1" style={{ color: ok ? COLORS[score] : "#ef4444" }} data-testid="password-strength-label">
        {ok ? LABELS[score] : "Heslo musí mít alespoň 10 znaků"}
      </p>
    </div>
  );
}
